import React from 'react';
export function Rules() {
  return <section className="bg-paper py-[58px] md:py-[76px]" data-id="element-76">
      <div className="max-w-page mx-auto px-6" data-id="element-77">
        <div className="text-center mb-10" data-id="element-78">
          <span className="text-[0.72rem] font-semibold tracking-[0.18em] uppercase text-teal block mb-[14px]" data-id="element-79">
            What we believe
          </span>
          <h2 className="font-display font-medium text-[clamp(1.8rem,3.4vw,2.5rem)] leading-[1.12] tracking-[-0.01em] m-0 mx-auto max-w-[20ch] text-balance" data-id="element-80">
            Three rules we build by
          </h2>
          <p className="text-ink-60 max-w-[54ch] mx-auto mt-4 mb-0 text-[1.02rem]" data-id="element-81">
            We're a wellness brand in a category full of hype and knockoffs. The
            way we stay worth trusting is to keep the promises small and the
            mechanism real.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[22px] md:gap-[26px]" data-id="element-82">
          <div className="bg-mist border border-hair rounded-[18px] py-[30px] px-[26px] relative" data-id="element-83">
            <div className="font-display italic text-[0.95rem] text-teal opacity-70 mb-[14px]" data-id="element-84">
              Rule one
            </div>
            <h3 className="font-display font-semibold text-[1.3rem] m-0 mb-[10px] tracking-[-0.01em]" data-id="element-85">
              Body first
            </h3>
            <p className="text-ink-60 m-0 text-[0.98rem]" data-id="element-86">
              We design for the hard moment, not the journal entry. When you're
              spiralling, the quickest way out is usually through the breath —
              not by arguing with the thoughts.
            </p>
          </div>

          <div className="bg-mist border border-hair rounded-[18px] py-[30px] px-[26px] relative" data-id="element-87">
            <div className="font-display italic text-[0.95rem] text-teal opacity-70 mb-[14px]" data-id="element-88">
              Rule two
            </div>
            <h3 className="font-display font-semibold text-[1.3rem] m-0 mb-[10px] tracking-[-0.01em]" data-id="element-89">
              Honest by default
            </h3>
            <p className="text-ink-60 m-0 text-[0.98rem]" data-id="element-90">
              We'd rather undersell. Chime isn't a cure, a treatment, or a
              replacement for therapy or medication — and we say so on every
              page, including this one.
            </p>
          </div>

          <div className="bg-mist border border-hair rounded-[18px] py-[30px] px-[26px] relative" data-id="element-91">
            <div className="font-display italic text-[0.95rem] text-teal opacity-70 mb-[14px]" data-id="element-92">
              Rule three
            </div>
            <h3 className="font-display font-semibold text-[1.3rem] m-0 mb-[10px] tracking-[-0.01em]" data-id="element-93">
              Analog on purpose
            </h3>
            <p className="text-ink-60 m-0 text-[0.98rem]" data-id="element-94">
              No app, no login, no streak to break. The thing that's meant to
              pull you off your phone shouldn't live on it.
            </p>
          </div>
        </div>
      </div>
    </section>;
}